import { Pipe, PipeTransform } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { RecoveryStatus } from 'mbs-ui-shared@models/backup/recovery-status.enum';

const PLAN_STATUS_ICON_CLASSES = [
  { status: RecoveryStatus.Succeed, icon: 'text-success' },
  { status: RecoveryStatus.Overdue, icon: 'text-danger' },
  { status: RecoveryStatus.Failed, icon: 'text-danger' },
  { status: RecoveryStatus.Warning, icon: 'text-warning' }
];
const PLAN_STATUS_ICON_DEFAULT_CLASS = 'text-black';

const PLAN_STATUS_TEXT = [
  { status: RecoveryStatus.Succeed, key: 'shared:sidepanel-backup.planStatus.success' },
  { status: RecoveryStatus.Failed, key: 'shared:sidepanel-backup.planStatus.fail' },
  { status: RecoveryStatus.Warning, key: 'shared:sidepanel-backup.planStatus.warning' },
  { status: RecoveryStatus.Started, key: 'shared:sidepanel-backup.planStatus.running' },
  { status: RecoveryStatus.Running, key: 'shared:sidepanel-backup.planStatus.running' },
  { status: RecoveryStatus.Overdue, key: 'shared:sidepanel-backup.planStatus.overdue' }
];
const PLAN_STATUS_DEFAULT_TEXT = 'shared:sidepanel-backup.planStatus.unknown';

@Pipe({
  name: 'planStatus'
})
export class PlanStatusPipe implements PipeTransform {
  constructor(private i18nPipe: I18NextPipe) {}

  transform(value: RecoveryStatus | RecoveryStatus, mode: 'icon' | 'display' = 'icon'): any {
    if (mode === 'display')
      return this.i18nPipe.transform(PLAN_STATUS_TEXT.find((item) => item.status === value)?.key ?? PLAN_STATUS_DEFAULT_TEXT);
    if (mode === 'icon') return PLAN_STATUS_ICON_CLASSES.find((item) => item.status === value)?.icon ?? PLAN_STATUS_ICON_DEFAULT_CLASS;

    console.error('PlanStatusPipe Error');
  }
}
